import * as actionTypes from './actionTypes';

const initialState = {
  activeRoleId: null,
  ids: [],
  rolesBySpaceId: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.SET_ACTIVE_ROLE_ID:
      return {
        ...state,
        activeRoleId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [...state.ids, action.role.id],
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter(id => id !== action.id),
        activeRoleId: action.id === state.activeRoleId ? null : state.activeRoleId,
      };
    case actionTypes.FETCH_ALL_SPACE_MEMBERS_SUCCESS:
      return {
        ...state,
        rolesBySpaceId: {
          ...state.rolesBySpaceId,
          [action.spaceId]: [...new Set(action.ids)], // ensure values are unique
        },
      };
    default:
      return state;
  }
};
